export const GET_STATIONERY_ITEMS = 'GET_STATIONERY_ITEMS';
export const GET_PURCHASED_STATIONERY = 'GET_PURCHASED_STATIONERY';
export const GET_STATIONERY_REQUEST = 'GET_STATIONERY_REQUEST';
export const GET_STATIONERY_PROPOSAL = 'GET_STATIONERY_PROPOSAL';
export const GET_STATIONERY_MOVMENT = 'GET_STATIONERY_MOVMENT';
export const GET_STATIONERY_COLLECTOR = 'GET_STATIONERY_COLLECTOR';
export const GET_STATIONERY_INVENTORY = 'GET_STATIONERY_INVENTORY';
export const GET_STATIONERY_DISTRIBUTERS = 'GET_STATIONERY_DISTRIBUTERS';